import * as React from 'react';
import { navigate } from 'mydish-ui-util';
import NavButton from './NavButton';
import Card from './Card';
import { ChildPage, SectionPage } from './DrawerComponent';

interface HoverNavListProps {
  sectionPages?: SectionPage[];
  childPages?: ChildPage[];
  active?: boolean;
  setSubMenuMousePosition?: Function;
  navIndex?: number;
  history?: any;
}

export default function HoverNavList(props: HoverNavListProps) {
  const [sectionPages, setSectionPages] = React.useState<
    SectionPage[] | undefined
  >();

  React.useEffect(() => {
    const allSectionPages = props.sectionPages?.map((page) =>
      page ? { ...page, collapsed: true } : page
    );
    setSectionPages(allSectionPages);
  }, [props.sectionPages, props.active]);
  let keyIndex = 0;
  return (
    <div className={`floating-drawer${props.active ? ' active' : ''}`}>
      <Card>
        {sectionPages &&
          sectionPages.map((sectionPage: SectionPage, index: number) => {
            if (!sectionPage) return null;
            keyIndex += 1;
            return (
              <div
                key={`${(sectionPage.name || 'sectionPage')
                  .toLowerCase()
                  .split(' ')
                  .join('')}${keyIndex}`}
                className={`navSection${
                  sectionPage.name ? ' collapsibleNav' : ''
                }`}
              >
                {sectionPage.name ? (
                  <>
                    <div className="sectionPage">
                      <button
                        type="button"
                        className="section-header"
                        onClick={(e) => {
                          const updatedPages = [...sectionPages];
                          updatedPages.forEach((obj: any, id: number) => {
                            if (id !== index && obj && !obj.collapsed) {
                              // eslint-disable-next-line no-param-reassign
                              obj.collapsed = true;
                            }
                          });
                          updatedPages[index].collapsed =
                            !updatedPages[index].collapsed;
                          setSectionPages(updatedPages);
                          if (props.setSubMenuMousePosition)
                            props.setSubMenuMousePosition(e.screenY);
                        }}
                      >
                        <h2 className="sectionTitle">{sectionPage.name}</h2>
                        <div
                          className={`navDropdownArrow${
                            sectionPage.collapsed ||
                            sectionPage.collapsed === undefined
                              ? ' collapsedArrow'
                              : ' expandedArrow'
                          }`}
                        />
                      </button>
                    </div>

                    <div
                      className={`navSectionChildren${
                        sectionPage.collapsed !== undefined
                          ? ` ${
                              sectionPage.collapsed
                                ? 'collapsedNav'
                                : 'expandedNav'
                            }`
                          : ''
                      }`}
                      id={`navSectionChildren-${props.navIndex}-${index}`}
                    >
                      {sectionPage.childPages.map(
                        (childPage: ChildPage, childPageIndex: number) => {
                          if (!sectionPage) return null;
                          const pageName = childPage.name || childPage.pageName;
                          const href = childPage.href || childPage.pageURL;
                          keyIndex += 1;
                          return (
                            <NavButton
                              id={`drawer-content-link-${props.navIndex}-${index}-${childPageIndex}`}
                              label={pageName}
                              className="drawer-content-link"
                              key={`${pageName
                                .toUpperCase()
                                .split(' ')
                                .join('')}${keyIndex}`}
                              disabled={sectionPage.collapsed}
                              onClick={() => {
                                navigate(href, props.history);
                              }}
                            />
                          );
                        }
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    {sectionPage.childPages?.map(
                      (childPage: ChildPage, childPageIndex: number) => {
                        const pageName = childPage.name || childPage.pageName;
                        const href = childPage.href || childPage.pageURL;
                        keyIndex += 1;
                        return (
                          <NavButton
                            id={`drawer-content-link-${props.navIndex}-${index}-${childPageIndex}`}
                            label={pageName}
                            className="drawer-content-link"
                            key={`${pageName
                              .toUpperCase()
                              .split(' ')
                              .join('')}${keyIndex}`}
                            onClick={() => {
                              navigate(href, props.history);
                            }}
                          />
                        );
                      }
                    )}
                  </>
                )}
              </div>
            );
          })}
        {props.childPages?.map(
          (childPage: ChildPage, childPageIndex: number) => {
            const pageName = childPage.name || childPage.pageName;
            const href = childPage.href || childPage.pageURL;
            keyIndex += 1;
            return (
              <NavButton
                id={`drawer-content-link-${props.navIndex}-${childPageIndex}`}
                label={pageName}
                className="drawer-content-link"
                key={`${pageName.toUpperCase().split(' ').join('')}${keyIndex}`}
                onClick={() => {
                  navigate(href, props.history);
                }}
              />
            );
          }
        )}
      </Card>
    </div>
  );
}
